import React from 'react';
import SEOHead from '../components/SEOHead';
import './Developer.css';

const Developer = () => {
  const socialLinks = [
    {
      name: "Instagram",
      url: "https://www.instagram.com/aminsweiti/", // TO BE ADDED - placeholder for now
      icon: "📷",
      description: "Follow my journey and behind-the-scenes content"
    },
    {
      name: "Twitter",
      url: "https://x.com/AminSweiti", // TO BE ADDED - placeholder for now  
      icon: "🐦",
      description: "Tech thoughts, updates, and random musings"
    },
  ];

  return (
    <>
      <SEOHead
        title="Developer - Meet the Creator of OneTimer"
        description="Connect with the developer behind OneTimer. Find social links, contact information, and learn about the person creating productivity tools."
        keywords="OneTimer developer, app creator, contact developer, social media"
        path="/developer"
      />
      <div className="developer-container">
      <div className="developer-header">
        <h1>Developer</h1>
        <p className="subtitle">Connect with the creator of OneTimer</p>
      </div>
      
      <div className="developer-content">
        <div className="developer-intro">
          <h2>Hello! 👋</h2>
          <p>
            I'm the developer behind OneTimer. I created this app to help people like me 
            who want to track focused time on their passions and build consistent habits. 
            Whether you're learning a new skill, working on a side project, or just want 
            to be more intentional with your time, OneTimer is designed to be simple and effective.
          </p>
          <p>
            Feel free to connect with me on social media! I love hearing from users, 
            getting feedback, and sharing the journey of building useful tools.
          </p>
        </div>
        
        <div className="social-links">
          <h3>Connect with me</h3>
          <div className="social-grid">
            {socialLinks.map((link, index) => (
              <a 
                key={index}
                href={link.url}
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="social-icon">{link.icon}</div>
                <div className="social-info">
                  <div className="social-name">{link.name}</div>
                  <div className="social-description">{link.description}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
        
        <div className="contact-section">
          <h3>Get in touch</h3>
          <p>
            Have feedback about OneTimer? Found a bug? Have an idea for a new feature? 
            I'd love to hear from you!
          </p>
          <a href="mailto:theonetimerapp@gmail.com" className="contact-button">
            Send me an email
          </a>
        </div>
      </div>
      </div>
    </>
  );
};

export default Developer;